document.addEventListener('DOMContentLoaded', function () {
    // Initialize variables
    let map = null;
    let userMarker = null;
    let storeMarkers = new Map();
    let routingControl = null;
    let userLocation = null;
    let storesData = [];
    let debounceTimeout;

    // Geocoding configuration
    const geocodeCache = new Map();
    const GEOCODE_DELAY = 250;
    const MAX_CONCURRENT_REQUESTS = 3;
    const MAX_RETRIES = 2;
    const MIN_SEARCH_LENGTH = 4;
    let activeGeocodingRequests = 0;
    const OPENCAGE_API_KEY = null; // Add your OpenCage API key here if available

    // Initialize map with performance optimizations
    function initMap() {
      const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches || window.innerWidth <= 768;
      if (!map) {
        const mapContainer = document.getElementById('map');
        mapContainer.classList.add('map-loading');

        map = L.map('map', {
          zoomControl: window.innerWidth > 768,
          attributionControl: false,
          preferCanvas: true,
          inertia: false,
          scrollWheelZoom: false,
          // Add these options to prevent focus-related scrolling
          keyboard: !isCoarsePointer,
          boxZoom: !isCoarsePointer,
          doubleClickZoom: !isCoarsePointer,
          zoomSnap: 1,
          zoomDelta: 1
        }).setView([43.6591, -70.2568], 12);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap',
          maxZoom: 18,
          tileSize: 256,
          detectRetina: false,
        }).addTo(map);

        map.on('load', function () {
          mapContainer.classList.remove('map-loading');
          
          // Fix zoom controls after map loads
          fixZoomControls();
        });

        // Force immediate size calculation
        setTimeout(() => {
          map.invalidateSize(true);
          // Also fix zoom controls after initialization
          fixZoomControls();
        }, 100);
      }
      return map;
    }

    // Add this new function to fix the zoom control behavior
    function fixZoomControls() {
      // Wait for zoom controls to be rendered
      setTimeout(() => {
        const zoomIn = document.querySelector('.leaflet-control-zoom-in');
        const zoomOut = document.querySelector('.leaflet-control-zoom-out');
        
        if (zoomIn) {
          // Remove existing event listeners and add custom ones
          const newZoomIn = zoomIn.cloneNode(true);
          zoomIn.parentNode.replaceChild(newZoomIn, zoomIn);
          
          newZoomIn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Store current scroll position
            const scrollTop = window.pageYOffset;
            const scrollLeft = window.pageXOffset;
            
            // Perform zoom
            map.zoomIn();
            
            // Restore scroll position immediately
            window.scrollTo(scrollLeft, scrollTop);
            
            return false;
          });
          
          // Prevent default link behavior
          newZoomIn.setAttribute('href', '#');
          newZoomIn.setAttribute('role', 'button');
          newZoomIn.setAttribute('tabindex', '0');
          newZoomIn.style.cursor = 'pointer';
          newZoomIn.addEventListener('keydown', function(e) {
             if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); e.stopPropagation();
              const scrollTop = window.pageYOffset, scrollLeft = window.pageXOffset;
              map.zoomIn();
              window.scrollTo(scrollLeft, scrollTop);
             }
          });
        }
        
        if (zoomOut) {
          // Remove existing event listeners and add custom ones
          const newZoomOut = zoomOut.cloneNode(true);
          zoomOut.parentNode.replaceChild(newZoomOut, zoomOut);
          
          newZoomOut.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Store current scroll position
            const scrollTop = window.pageYOffset;
            const scrollLeft = window.pageXOffset;
            
            // Perform zoom
            map.zoomOut();
            
            // Restore scroll position immediately
            window.scrollTo(scrollLeft, scrollTop);
            
            return false;
          });
          
          // Prevent default link behavior
          newZoomOut.setAttribute('href', '#');
          newZoomOut.setAttribute('role', 'button');
          newZoomOut.setAttribute('tabindex', '0');
          newZoomOut.style.cursor = 'pointer';
          newZoomOut.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); e.stopPropagation();
              const scrollTop = window.pageYOffset, scrollLeft = window.pageXOffset;
              map.zoomOut();
              window.scrollTo(scrollLeft, scrollTop);
            }
          });
        }
      }, 200);
    }

    // Also add this CSS prevention (add to your CSS file or include as a style tag)
    function addScrollPreventionCSS() {
      if (!document.getElementById('map-scroll-fix')) {
        const style = document.createElement('style');
        style.id = 'map-scroll-fix';
        style.textContent = `
          .leaflet-control-zoom a {
            display: block !important;
            text-decoration: none !important;
            outline: none !important;
          }
          
          .leaflet-control-zoom a:focus,
          .leaflet-control-zoom a:active,
          .leaflet-control-zoom a:visited {
            outline: none !important;
            box-shadow: none !important;
          }
          
          .leaflet-container {
            outline: none !important;
          }
          
          .leaflet-container:focus {
            outline: none !important;
          }
          
          /* Prevent any scrollIntoView behavior */
          .leaflet-control-zoom * {
            scroll-behavior: auto !important;
          }
        `;
        document.head.appendChild(style);
      }
    }

    // Call this function when the document loads
    
      addScrollPreventionCSS();
    

    // Preload map for mobile with lazy loading approach
    function preloadMapForMobile() {
      if (window.innerWidth <= 768 && !map) {
        // Only preload if the map tab might be shown soon
        const observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              initMap();
              initStoreMarkers();
              observer.disconnect();
            }
          },
          {rootMargin: '200px'},
        );

        observer.observe(document.querySelector('.mobile-tab[data-tab="map"]'));
      }
    }

    // IP-based geolocation that works with VPNs
    async function getIPBasedLocation() {
      try {
        // Using ipapi.co (free service, works with VPNs)
        const response = await fetch('https://ipapi.co/json/', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.latitude && data.longitude && data.latitude !== 0 && data.longitude !== 0) {
          return {
            lat: data.latitude,
            lng: data.longitude,
            city: data.city || '',
            region: data.region || '',
            country: data.country_name || data.country || '',
            address: `${data.city || ''}, ${data.region || ''}, ${data.country_name || data.country || ''}`.replace(/^,\s*|,\s*$/g, '').replace(/,\s*,/g, ',')
          };
        } else {
          throw new Error('Invalid coordinates received');
        }
      } catch (error) {
        console.error('ipapi.co failed:', error);
        
        // Fallback to ipinfo.io
        try {
          const response = await fetch('https://ipinfo.io/json', {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
            }
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const data = await response.json();
          
          if (data.loc) {
            const [lat, lng] = data.loc.split(',');
            const latitude = parseFloat(lat);
            const longitude = parseFloat(lng);
            
            if (!isNaN(latitude) && !isNaN(longitude) && latitude !== 0 && longitude !== 0) {
              return {
                lat: latitude,
                lng: longitude,
                city: data.city || '',
                region: data.region || '',
                country: data.country || '',
                address: `${data.city || ''}, ${data.region || ''}, ${data.country || ''}`.replace(/^,\s*|,\s*$/g, '').replace(/,\s*,/g, ',')
              };
            }
          }
          throw new Error('Invalid location data from fallback service');
        } catch (fallbackError) {
          console.error('ipinfo.io also failed:', fallbackError);
          throw new Error('All IP geolocation services failed');
        }
      }
    }

    // Optimized geocoding with retry and fallback
    async function geocodeAddress(address, retryCount = 0) {
      const normalizedAddress = address.trim().toLowerCase();

      if (geocodeCache.has(normalizedAddress)) {
        return geocodeCache.get(normalizedAddress);
      }

      while (activeGeocodingRequests >= MAX_CONCURRENT_REQUESTS) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      activeGeocodingRequests++;
      const isMobile = window.innerWidth <= 768;
      const statusElement = document.getElementById(isMobile ? 'mobileLocationStatus' : 'desktopLocationStatus');

      try {
        const query = encodeURIComponent(address);
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${query}&limit=1&addressdetails=1`,
          {
            headers: {
              'User-Agent': 'StoreLocatorApp/1.0 (contact: support@example.com)',
            },
          },
        );

        if (!response.ok) {
          throw new Error(`Nominatim HTTP error: ${response.status}`);
        }

        const data = await response.json();
        let result = null;

        if (data && data.length > 0) {
          result = {
            lat: parseFloat(data[0].lat),
            lng: parseFloat(data[0].lon),
            fullAddress: data[0].display_name,
          };
        } else if (OPENCAGE_API_KEY && retryCount < MAX_RETRIES) {
          statusElement.textContent = 'Trying alternative geocoding service...';
          const openCageResult = await fetch(
            `https://api.opencagedata.com/geocode/v1/json?q=${query}&key=${OPENCAGE_API_KEY}&limit=1`,
          );
          const openCageData = await openCageResult.json();
          if (openCageData.results && openCageData.results.length > 0) {
            result = {
              lat: openCageData.results[0].geometry.lat,
              lng: openCageData.results[0].geometry.lng,
              fullAddress: openCageData.results[0].formatted,
            };
          }
        } else if (retryCount < MAX_RETRIES) {
          const simplifiedAddress = simplifyAddress(address);
          if (simplifiedAddress !== address) {
            statusElement.textContent = `Retrying with simplified address: ${simplifiedAddress}`;
            return await geocodeAddress(simplifiedAddress, retryCount + 1);
          }
        }

        geocodeCache.set(normalizedAddress, result);
        return result;
      } catch (error) {
        console.error(`Geocoding error for "${address}" (attempt ${retryCount + 1}):`, error);
        if (retryCount < MAX_RETRIES) {
          statusElement.textContent = `Retrying geocoding (attempt ${retryCount + 2})...`;
          await new Promise((resolve) => setTimeout(resolve, GEOCODE_DELAY * (retryCount + 1)));
          return await geocodeAddress(address, retryCount + 1);
        }
        geocodeCache.set(normalizedAddress, null);
        return null;
      } finally {
        activeGeocodingRequests--;
        await new Promise((resolve) => setTimeout(resolve, GEOCODE_DELAY));
      }
    }

    function simplifyAddress(address) {
      const match = address.match(/(.+),\s*([^,]+),\s*([A-Z]{2})\s*(\d{5})/);
      if (match) {
        return `${match[2].trim()}, ${match[3]} ${match[4]}`;
      }
      return address;
    }

    // Initialize store markers with optimized loading
    async function initStoreMarkers() {
      if (!map) return;

      storeMarkers.forEach((marker) => map.removeLayer(marker));
      storeMarkers.clear();

      storesData = Array.from(document.querySelectorAll('.store')).map((store, index) => ({
        id: index,
        element: store,
        address: store.dataset.address,
        name: store.dataset.name,
        lat: parseFloat(store.dataset.lat) || null,
        lng: parseFloat(store.dataset.lng) || null,
        distance: null, // Initialize distance
      }));

      // First pass - only add markers with existing coordinates
      const storesWithCoords = storesData.filter(
        (store) => store.lat && store.lng && !isNaN(store.lat) && !isNaN(store.lng),
      );

      storesWithCoords.forEach((store) => {
        addStoreMarker(store);
      });

      // Second pass - geocode others in background
      const storesToGeocode = storesData.filter(
        (store) => (!store.lat || !store.lng || isNaN(store.lat) || isNaN(store.lng)) && store.address,
      );

      if (storesToGeocode.length > 0) {
        geocodeStoresInBackground(storesToGeocode);
      }

      // Set initial view if we have markers
      if (storesWithCoords.length > 0) {
        const markers = Array.from(storeMarkers.values());
        if (markers.length > 0) {
          map.fitBounds(L.featureGroup(markers).getBounds().pad(0.1), {
            animate: false,
            duration: 0,
          });
        }
      }
    }

    async function geocodeStoresInBackground(stores) {
      const BATCH_SIZE = 2;
      const DELAY_BETWEEN_BATCHES = 500;

      for (let i = 0; i < stores.length; i += BATCH_SIZE) {
        const batch = stores.slice(i, i + BATCH_SIZE);
        await Promise.all(batch.map((store) => geocodeAndAddStore(store)));
        await new Promise((resolve) => setTimeout(resolve, DELAY_BETWEEN_BATCHES));
      }
    }

    async function geocodeAndAddStore(store) {
      const result = await geocodeAddress(store.address);
      if (result && result.lat && result.lng) {
        store.lat = result.lat;
        store.lng = result.lng;
        store.element.dataset.lat = result.lat;
        store.element.dataset.lng = result.lng;
        addStoreMarker(store);

        if (userLocation) {
          updateStoreDistance(store);
          // Re-sort stores after each new one is geocoded
          sortAndReorderStores();
        }
      }
    }

    function addStoreMarker(store) {
      if (!map || !store.lat || !store.lng) return;

      const marker = L.marker([store.lat, store.lng], {
  icon: L.divIcon({
    className: 'store-marker-icon',
    html: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
             <path d="M17.6571 5.30377C14.5331 2.23077 9.46814 2.23077 6.34414 5.30377C5.60242 6.02841 5.01305 6.894 4.61066 7.84968C4.20826 8.80536 4.00098 9.83184 4.00098 10.8688C4.00098 11.9057 4.20826 12.9322 4.61066 13.8879C5.01305 14.8435 5.60242 15.7091 6.34414 16.4338L12.0001 21.9988L17.6571 16.4338C18.3989 15.7091 18.9882 14.8435 19.3906 13.8879C19.793 12.9322 20.0003 11.9057 20.0003 10.8688C20.0003 9.83184 19.793 8.80536 19.3906 7.84968C18.9882 6.894 18.3989 6.02841 17.6571 5.30377ZM12.0001 13.4988C11.3321 13.4988 10.7051 13.2388 10.2321 12.7668C9.76389 12.2975 9.50092 11.6617 9.50092 10.9988C9.50092 10.3359 9.76389 9.70002 10.2321 9.23077C10.7041 8.75877 11.3321 8.49877 12.0001 8.49877C12.6681 8.49877 13.2961 8.75877 13.7681 9.23077C14.2364 9.70002 14.4994 10.3359 14.4994 10.9988C14.4994 11.6617 14.2364 12.2975 13.7681 12.7668C13.2961 13.2388 12.6681 13.4988 12.0001 13.4988Z" fill="#2a5885"/>
           </svg>`,
    iconSize: [24, 24],
    iconAnchor: [12, 24], // Point of the pin that corresponds to marker location
  }),
}).addTo(map);

      marker.bindPopup(
        `<div class="map-popup">
         <h3>${store.name}</h3>
         <p>${store.address}</p>
         <p class="distance"></p>
       </div>`,
      );

      storeMarkers.set(store.id, marker);
      
      if (userLocation) {
        updateStoreDistance(store);
      }
    }

    function updateStoreDistance(store) {
      if (userLocation && store.lat && store.lng) {
        const distance = calculateDistance(userLocation.lat, userLocation.lng, store.lat, store.lng);
        store.distance = distance;

        // Update distance display in the store element
        let distanceElement = store.element.querySelector('.distance');
        if (!distanceElement) {
          // Create distance element if it doesn't exist
          distanceElement = document.createElement('p');
          distanceElement.className = 'distance text-[#424242] text-[14px] font-medium not-italic leading-[21px] tracking-normal mt-2';
          const storeTextsContent = store.element.querySelector('.store-texts-content');
          if (storeTextsContent) {
            storeTextsContent.appendChild(distanceElement);
          } else {
            store.element.appendChild(distanceElement);
          }
        }
        distanceElement.textContent = `${distance.toFixed(1)} miles away`;
        distanceElement.classList.remove('hidden');

        // Update marker popup
        const marker = storeMarkers.get(store.id);
        if (marker) {
          marker.setPopupContent(
            `<div class="map-popup">
             <h3>${store.name}</h3>
             <p>${store.address}</p>
             <p>${distance.toFixed(1)} miles away</p>
           </div>`,
          );
        }
      }
    }

    // New function to sort and reorder stores
    function sortAndReorderStores() {
      if (!userLocation) return;

      // Update distances for all stores with coordinates
      storesData.forEach((store) => {
        if (store.lat && store.lng) {
          updateStoreDistance(store);
        }
      });

      // Sort stores by distance (stores without distance go to the end)
      storesData.sort((a, b) => {
        if (a.distance === null && b.distance === null) return 0;
        if (a.distance === null) return 1;
        if (b.distance === null) return -1;
        return a.distance - b.distance;
      });

      // Reorder DOM elements
      const storesContainer = document.querySelector('.store-locator__stores');
      if (storesContainer) {
        const fragment = document.createDocumentFragment();
        storesData.forEach((store) => {
          fragment.appendChild(store.element);
        });
        storesContainer.appendChild(fragment);
      }

      // console.log('Stores sorted by distance:', storesData.map(s => ({name: s.name, distance: s.distance})));
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 3959;
      const dLat = ((lat2 - lat1) * Math.PI) / 180;
      const dLon = ((lon2 - lon1) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    function setUserLocation(lat, lng, label) {
      userLocation = {lat, lng};

      if (!map) {
        initMap();
        initStoreMarkers();
      }

      if (userMarker) map.removeLayer(userMarker);

      userMarker = L.marker([lat, lng], {
  icon: L.divIcon({
    className: 'user-location-icon',
    html: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
             <path d="M17.6571 5.30377C14.5331 2.23077 9.46814 2.23077 6.34414 5.30377C5.60242 6.02841 5.01305 6.894 4.61066 7.84968C4.20826 8.80536 4.00098 9.83184 4.00098 10.8688C4.00098 11.9057 4.20826 12.9322 4.61066 13.8879C5.01305 14.8435 5.60242 15.7091 6.34414 16.4338L12.0001 21.9988L17.6571 16.4338C18.3989 15.7091 18.9882 14.8435 19.3906 13.8879C19.793 12.9322 20.0003 11.9057 20.0003 10.8688C20.0003 9.83184 19.793 8.80536 19.3906 7.84968C18.9882 6.894 18.3989 6.02841 17.6571 5.30377ZM12.0001 13.4988C11.3321 13.4988 10.7051 13.2388 10.2321 12.7668C9.76389 12.2975 9.50092 11.6617 9.50092 10.9988C9.50092 10.3359 9.76389 9.70002 10.2321 9.23077C10.7041 8.75877 11.3321 8.49877 12.0001 8.49877C12.6681 8.49877 13.2961 8.75877 13.7681 9.23077C14.2364 9.70002 14.4994 10.3359 14.4994 10.9988C14.4994 11.6617 14.2364 12.2975 13.7681 12.7668C13.2961 13.2388 12.6681 13.4988 12.0001 13.4988Z" fill="#e74c3c"/>
           </svg>`,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
  }),
})
        .addTo(map)
        .bindPopup(`<div class="map-popup"><h3>Your Location</h3><p>${label}</p></div>`);

      // Sort and reorder stores by distance
      sortAndReorderStores();

      // Set view to show user and nearest stores
      const markers = Array.from(storeMarkers.values());
      if (userMarker) markers.push(userMarker);
      if (markers.length > 0) {
        map.fitBounds(L.featureGroup(markers).getBounds().pad(0.1), {
          animate: false,
          duration: 0,
        });
      }

      // Enable direct me buttons
      document.querySelectorAll('.direct-me').forEach((btn) => {
        btn.disabled = false;
        if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
      });
    }

    // Mobile tab functionality
    const mobileTabs = document.querySelectorAll('.mobile-tab');
    mobileTabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        mobileTabs.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');

        const storesList = document.querySelector('.stores-list');
        const mapContainer = document.getElementById('map');
        const tabId = this.dataset.tab;

        storesList.style.display = tabId === 'stores' ? 'block' : 'none';
        mapContainer.style.display = tabId === 'map' ? 'block' : 'none';
        storesList.classList.toggle('active-tab', tabId === 'stores');
        mapContainer.classList.toggle('active-tab', tabId === 'map');

        if (tabId === 'map') {
          if (!map) {
            initMap();
            initStoreMarkers();
          }
          setTimeout(() => {
            map.invalidateSize(true);
            if (userLocation || storeMarkers.size > 0) {
              const markers = Array.from(storeMarkers.values());
              if (userMarker) markers.push(userMarker);
              if (markers.length > 0) {
                map.fitBounds(L.featureGroup(markers).getBounds().pad(0.1), {
                  animate: false,
                  duration: 0,
                });
              }
            }
          }, 50);
        }
      });
    });

    // Direct Me button handler
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('direct-me')) {
        const storeCard = e.target.closest('.store');
        const storeIndex = storesData.findIndex((store) => store.element === storeCard);
        const store = storesData[storeIndex];

        if (store && userLocation && store.lat && store.lng) {
          if (window.innerWidth <= 768) {
            document.querySelectorAll('.mobile-tab').forEach((t) => t.classList.remove('active'));
            const mapTab = document.querySelector('.mobile-tab[data-tab="map"]');
            mapTab.classList.add('active');

            document.querySelectorAll('.stores-list, .map-container').forEach((el) => {
              el.style.display = 'none';
              el.classList.remove('active-tab');
            });
            const mapContainer = document.getElementById('map');
            mapContainer.style.display = 'block';
            mapContainer.classList.add('active-tab');

            if (!map) {
              initMap();
              initStoreMarkers();
            }
            setTimeout(() => {
              map.invalidateSize(true);
            }, 50);
          }

          const distance = calculateDistance(userLocation.lat, userLocation.lng, store.lat, store.lng);
          showDirectionsOptimized(userLocation.lat, userLocation.lng, store.lat, store.lng, store.name, distance);
        }
      }
    });

    function showDirectionsOptimized(fromLat, fromLng, toLat, toLng, storeName, distance) {
      if (routingControl) {
        try {
          map.removeControl(routingControl);
        } catch (e) {
          console.error('Error removing routing control:', e);
        }
      }

      const isMobile = window.innerWidth <= 768;

      routingControl = L.Routing.control({
        waypoints: [L.latLng(fromLat, fromLng), L.latLng(toLat, toLng)],
        routeWhileDragging: false,
        addWaypoints: false,
        createMarker: () => null,
        lineOptions: {
          styles: [{color: '#6FA1EC', weight: isMobile ? 2 : 4, opacity: 0.7}],
        },
        router: L.Routing.osrmv1({
          serviceUrl: 'https://router.project-osrm.org/route/v1',
          profile: 'driving',
          timeout: 10000,
        }),
        show: true,
        collapsible: isMobile,
        fitSelectedRoutes: false,
        showAlternatives: false,
      }).addTo(map);

      routingControl.on('routingerror', function (e) {
        console.error('Routing error:', e.error);
        const statusElement = document.getElementById(isMobile ? 'mobileLocationStatus' : 'desktopLocationStatus');
        statusElement.textContent = 'Could not generate route. Please try again.';
      });

      document.querySelectorAll('.store').forEach((s) => s.classList.remove('active'));
      const targetStore = storesData.find((s) => s.name === storeName);
      if (targetStore) {
        targetStore.element.classList.add('active');
        const marker = storeMarkers.get(targetStore.id);
        if (marker) {
          marker.setPopupContent(
            `<div class="map-popup">
             <h3>${storeName}</h3>
             <p>${targetStore.address}</p>
             <p>${distance.toFixed(1)} miles away</p>
           </div>`,
          );
          marker.openPopup();
        }
      }

      routingControl.on('routesfound', function (e) {
        const routes = e.routes;
        if (routes && routes.length > 0) {
          const bounds = L.latLngBounds([
            [fromLat, fromLng],
            [toLat, toLng],
          ]).pad(0.1);
          map.fitBounds(bounds, {animate: false});
          const statusElement = document.getElementById(isMobile ? 'mobileLocationStatus' : 'desktopLocationStatus');
          statusElement.textContent = `Route to ${storeName} calculated. Distance: ${distance.toFixed(1)} miles.`;
        }
      });

      setTimeout(
        () => {
          map.invalidateSize(true);
        },
        isMobile ? 100 : 200,
      );
    }

    // Reset map to default state
    function resetMapToDefault() {
      // Clear user location
      userLocation = null;
      
      // Remove user marker
      if (userMarker && map) {
        map.removeLayer(userMarker);
        userMarker = null;
      }
      
      // Remove routing control
      if (routingControl && map) {
        try {
          map.removeControl(routingControl);
          routingControl = null;
        } catch (e) {
          console.error('Error removing routing control:', e);
        }
      }
      
      // Reset all store distances and hide distance elements
      storesData.forEach((store) => {
        store.distance = null;
        
        // Hide distance element
        const distanceElement = store.element.querySelector('.distance');
        if (distanceElement) {
          distanceElement.classList.add('hidden');
        }
        
        // Update marker popup to remove distance
        const marker = storeMarkers.get(store.id);
        if (marker) {
          marker.setPopupContent(
            `<div class="map-popup">
             <h3>${store.name}</h3>
             <p>${store.address}</p>
           </div>`
          );
        }
      });
      
      // Reset store order to original (by index)
      storesData.sort((a, b) => a.id - b.id);
      const storesContainer = document.querySelector('.store-locator__stores');
      if (storesContainer) {
        const fragment = document.createDocumentFragment();
        storesData.forEach((store) => {
          fragment.appendChild(store.element);
        });
        storesContainer.appendChild(fragment);
      }
      
      // Remove active class from all stores
      document.querySelectorAll('.store').forEach((s) => s.classList.remove('active'));
      
      // Disable direct me buttons
      document.querySelectorAll('.direct-me').forEach((btn) => {
        btn.disabled = true;
      });
      
      // Reset map view to show all store markers
      if (map && storeMarkers.size > 0) {
        const markers = Array.from(storeMarkers.values());
        map.fitBounds(L.featureGroup(markers).getBounds().pad(0.1), {
          animate: false,
          duration: 0,
        });
      } else if (map) {
        // Fallback to default view if no store markers
        map.setView([43.6591, -70.2568], 12);
      }
      
      // console.log('Map reset to default state');
    }

    function isValidZipCode(zipCode) {
      return /^\d{5}(-\d{4})?$/.test(zipCode);
    }

    async function searchByZipCode(zipCode) {
      // Use Nominatim for ZIP code geocoding (free service)
      const query = encodeURIComponent(`${zipCode}, United States`);
      const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${query}&countrycodes=us&limit=1`,
          {
              headers: {
                  'Accept': 'application/json',
                  'User-Agent': 'StoreLocator/1.0'
              }
          }
      );

      if (!response.ok) {
          throw new Error('Failed to fetch location data');
      }

      const data = await response.json();
      
      if (data && data.length > 0) {
          return {
              lat: parseFloat(data[0].lat),
              lng: parseFloat(data[0].lon),
              address: data[0].display_name
          };
      }
      throw new Error('ZIP code not found');
    }

    // Address search handler function
    function handleAddressSearch(inputElement, statusElement) {
      inputElement.addEventListener('input', function() {
        clearTimeout(debounceTimeout);
        const input = this.value.trim();

        // If input is empty, reset the map
        if (input.length === 0) {
            resetMapToDefault();
            statusElement.textContent = '';
            return;
        }

        // Check if input is a ZIP code
        if (isValidZipCode(input)) {
            debounceTimeout = setTimeout(async () => {
                statusElement.textContent = 'Searching ZIP code...';
                try {
                    const location = await searchByZipCode(input);
                    setUserLocation(location.lat, location.lng, location.address);
                    statusElement.textContent = 'ZIP code found! Stores sorted by distance.';
                    
                    // Update both input fields with the full address
                    document.getElementById('mobileAddressInput').value = location.address;
                    document.getElementById('desktopAddressInput').value = location.address;
                } catch (error) {
                    statusElement.textContent = 'Invalid ZIP code or location not found.';
                    console.error('ZIP code search error:', error);
                }
            }, 500);
            return;
        }

        // Handle regular address search
        if (input.length < MIN_SEARCH_LENGTH) {
          statusElement.textContent = `Type at least ${MIN_SEARCH_LENGTH} characters to search...`;
          return;
        }

        debounceTimeout = setTimeout(async () => {
          statusElement.textContent = 'Searching for address...';
          const result = await geocodeAddress(input);

          if (result && result.lat && result.lng) {
            setUserLocation(result.lat, result.lng, result.fullAddress || input);
            statusElement.textContent = 'Address found! Stores sorted by distance.';
          } else {
            statusElement.textContent = 'Address not found. Try including city and state.';
          }
        }, window.innerWidth <= 768 ? 1000 : 600);
      });

      // Keep existing keyboard event listener
      inputElement.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && this.value.trim() !== '') {
          this.value = '';
          resetMapToDefault();
          statusElement.textContent = '';
        }
      });
    }

    // Updated handleGetLocation function that uses IP-based location
    function handleGetLocation(buttonElement, statusElement) {
      buttonElement.addEventListener('click', async () => {
        statusElement.textContent = 'Getting your current location...';
        statusElement.classList.remove('hidden');
        
        try {
          const location = await getIPBasedLocation();
          
          // Set the location on the map
          setUserLocation(location.lat, location.lng, location.address || 'Current Location');
          
          // Update status
          statusElement.textContent = `Location found: ${location.address}. Stores sorted by distance.`;
          
          // Update both input fields with the address
          const mobileInput = document.getElementById('mobileAddressInput');
          const desktopInput = document.getElementById('desktopAddressInput');
          
          if (mobileInput) mobileInput.value = location.address;
          if (desktopInput) desktopInput.value = location.address;
          
        } catch (error) {
          console.error('Location detection failed:', error);
          statusElement.textContent = 'Unable to detect your location. Please enter an address manually.';
        }
      });
    }

    // Handle clear/reset button functionality
    function handleClearButton(buttonElement, inputElement, statusElement) {
      buttonElement.addEventListener('click', () => {
        inputElement.value = '';
        resetMapToDefault();
        statusElement.textContent = '';
        inputElement.focus();
      });
    }

    // Initialize both mobile and desktop search handlers
    const mobileAddressInput = document.getElementById('mobileAddressInput');
    const mobileLocationStatus = document.getElementById('mobileLocationStatus');
    const mobileGetLocationBtn = document.getElementById('mobileGetLocationBtn');
    const mobileClearBtn = document.getElementById('mobileClearBtn'); // Optional clear button

    const desktopAddressInput = document.getElementById('desktopAddressInput');
    const desktopLocationStatus = document.getElementById('desktopLocationStatus');
    const desktopGetLocationBtn = document.getElementById('desktopGetLocationBtn');
    const desktopClearBtn = document.getElementById('desktopClearBtn'); // Optional clear button

    handleAddressSearch(mobileAddressInput, mobileLocationStatus);
    handleGetLocation(mobileGetLocationBtn, mobileLocationStatus);
    handleAddressSearch(desktopAddressInput, desktopLocationStatus);
    handleGetLocation(desktopGetLocationBtn, desktopLocationStatus);

    // Handle clear buttons if they exist
    if (mobileClearBtn) {
      handleClearButton(mobileClearBtn, mobileAddressInput, mobileLocationStatus);
    }
    if (desktopClearBtn) {
      handleClearButton(desktopClearBtn, desktopAddressInput, desktopLocationStatus);
    }

    // Initialize the map immediately for desktop, lazy load for mobile
    if (window.innerWidth > 768) {
      initMap();
      initStoreMarkers();
      document.querySelector('.mobile-tabs').style.display = 'none';
    } else {
      document.querySelector('.map-container').style.display = 'none';
      document.querySelector('.stores-list').style.display = 'block';
      preloadMapForMobile();
    }

    // Optimized resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth > 768) {
          // Desktop view
          document.querySelector('.stores-list').style.display = 'block';
          document.querySelector('.map-container').style.display = 'block';
          document.querySelector('.mobile-tabs').style.display = 'none';
          document.querySelector('.mobile-search').style.display = 'none';
          document.querySelector('.desktop-search').style.display = 'flex';
          if (!map) {
            initMap();
            initStoreMarkers();
          }
        } else {
          // Mobile view
          document.querySelector('.mobile-tabs').style.display = 'flex';
          document.querySelector('.mobile-search').style.display = 'flex';
          document.querySelector('.desktop-search').style.display = 'none';
          const activeTab = document.querySelector('.mobile-tab.active');
          document.querySelectorAll('.stores-list, .map-container').forEach((el) => (el.style.display = 'none'));
          if (activeTab.dataset.tab === 'map') {
            document.getElementById('map').style.display = 'block';
          } else {
            document.getElementById('stores-tab').style.display = 'block';
          }
        }
        if (map) {
          map.invalidateSize(true);
        }
      }, 100);
    });
  });